const MILLIONS = 1_000_000;

const convertToMillions = (value: number, decimal = 2) => {
  const decimalFactor = 10 ** decimal;

  return Math.round((value / MILLIONS) * decimalFactor) / decimalFactor;
};

export { convertToMillions, MILLIONS };
